import Header from './components/Header';
import Hero from './components/Hero';
import Comments from './components/Comments';
import Updates from './components/Updates';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import Features from './components/Features';
import Ranking from './components/Ranking';
import Cards from './components/Cards';
import FAQ from './components/FAQ';
import Carousel from './components/Carousel';
import AppEntry from './components/AppEntry';
import IndexSection from './components/IndexSection';
import Topics from './components/Topics';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <Hero />
      <main>
        <Comments />
        <Updates />
        <ContactSection />
        <AboutSection />
        <Features />
        <Ranking />
        <Cards />
        <FAQ />
        <Carousel />
        <AppEntry />
        <IndexSection />
        <Topics />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}